import {
  notifyError,
  useNotifications,
  notifySuccess,
} from 'Logic/Notifications.js'
import { useMutation } from 'Data/Api'
import { useDataChange } from 'Simple/Data'
import createMutation from './mutation-create-board.graphql.js'
import updateMutation from './mutation-update-board.graphql.js'

/** @type {import('Simple/types.js').useDataOnSubmit} */
export default function useDataOnSubmit(props, data) {
  let [, notify] = useNotifications()

  let [, executeCreateMutation] = useMutation(createMutation)
  let [, executeUpdateMutation] = useMutation(updateMutation)

  let tabChange = useDataChange({
    context: 'tab',
    viewPath: props.viewPath,
  })

  return async function onSubmit({ value, originalValue, args, change }) {
    switch (args.type) {
      case 'create': {
        let rvalue = args.value

        let mutationResponse = await executeCreateMutation({
          stages: rvalue.stages,
          metadata: {
            locations: rvalue.locations,
            board_icon_id: rvalue.board_icon_id,
          },
          name: rvalue.name,
        })

        if (mutationResponse.error) {
          notify(
            notifyError(
              'Cannot create Board. Names for boards must be unique. Please try again.'
            )
          )
          return
        }

        notify(notifySuccess(`Board ${rvalue.name} created.`))

        tabChange(next => {
          next.selected.board_id =
            mutationResponse.data.tasks_create_board_and_stages.id
          next.selected.board_submenu_tab_id = 'Board'
          next.selected.has_changes = false
        })

        return
      }

      case 'update': {
        let rvalue = args.value

        let mutationResponse = await executeUpdateMutation({
          id: rvalue.id,
          // rename from text to name
          stages: rvalue.stages.map(({ text, ...rest }) => ({
            ...rest,
            name: text,
          })),
          metadata: {
            ...value.metadata,
            locations: rvalue.locations,
            board_icon_id: rvalue.board_icon_id,
          },
          name: rvalue.name,
        })

        if (mutationResponse.error) {
          notify(
            notifyError(
              'Cannot update Board. Names for boards must be unique. Please try again.'
            )
          )
          return
        }

        notify(notifySuccess(`Board ${rvalue.name} updated.`))

        tabChange(next => {
          next.selected.has_changes = false
        })

        return
      }

      default: {
        return
      }
    }
  }
}
